// src/api/recruitmentAnalytics.ts
import api from './client';

export interface FunnelMetrics {
  applications: number;
  screenings: number;
  interviews: number;
  offers: number;
  hires: number;
  rejections: number;
}

export interface TimeMetrics {
  avgTimeToFill: number;
  avgTimeToHire: number;
  filledVacancies: number;
  hiredCandidates: number;
}

export interface CostMetrics {
  totalCost: number;
  avgCostPerHire: number;
  closedVacancies: number;
}

export interface SourceEffectiveness {
  source: string;
  applications: number;
  hires: number;
  conversionRate: string;
}

export interface QualityMetrics {
  retentionRate90d: number;
  retentionRate180d: number;
  avgPerformanceScore: string;
}

export interface RecruitmentAnalytics {
  period: string;
  dateRange: { start: string; end: string };
  funnel: FunnelMetrics;
  timeMetrics: TimeMetrics;
  costMetrics: CostMetrics;
  sourceEffectiveness: SourceEffectiveness[];
  qualityMetrics: QualityMetrics;
  vacancyBreakdown: any[];
  summary: {
    totalVacancies: number;
    totalCandidates: number;
    totalHires: number;
    overallConversionRate: string;
  };
}

export const getRecruitmentAnalytics = async (params?: {
  startDate?: string;
  endDate?: string;
  period?: 'day' | 'week' | 'month';
}): Promise<RecruitmentAnalytics> => {
  const res = await api.get('/recruitment-analytics', { params });
  return res.data;
};

export const getRecruitmentTrends = async (params?: {
  metric?: string;
  days?: number;
}): Promise<any[]> => {
  const res = await api.get('/recruitment-analytics/trends', { params });
  return res.data;
};

export const getRecommendations = async (): Promise<{ recommendations: any[] }> => {
  const res = await api.get('/recruitment-analytics/recommendations');
  return res.data;
};

export const getPredictiveAnalytics = async (): Promise<{
  predictedTimeToFill: number;
  predictedHiresNextMonth: number;
  attritionRisk: { department: string; risk: number }[];
}> => {
  const res = await api.get('/recruitment-analytics/predictive');
  return res.data;
};

export const exportRecruitmentReport = async (format: 'csv' | 'excel' = 'excel'): Promise<Blob> => {
  const res = await api.get('/recruitment-analytics/export', {
    params: { format },
    responseType: 'blob',
  });
  return res.data;
};

// Новые функции для расширенной аналитики
export const getStageDuration = async (): Promise<{ stage: string; avgDays: number }[]> => {
  const res = await api.get('/recruitment-analytics/stage-duration');
  return res.data;
};

export const getComparisonFunnel = async (): Promise<{
  current: FunnelMetrics;
  previous: FunnelMetrics;
}> => {
  const res = await api.get('/recruitment-analytics/comparison-funnel');
  return res.data;
};